<template lang="pug">
  div.transient
    v-toolbar(dense)
      v-col(cols='8' no-gutters)
        div.text-body-2.text-truncate {{key}}
        div.text-caption.grey--text.text--darken-1.text-truncate {{accountName}}
    bionic-metrics-page-loading(v-if='loading')
    bionic-metrics-monaco-simple-editor.full(
      v-if='!loading && json'
      ref='editor'
      v-model='json'
      git-name='transient.json'
      mode='json')
</template>

<script>
import {get, omit} from 'lodash';
import BionicMetricsPageLoading from '@/components/PageLoading';
import BionicMetricsNoData from '@/components/NoData';
import BionicMetricsMonacoSimpleEditor from '@/components/MonacoSimpleEditor';
import SuperAdmin from '../../../api/superAdmin';

export default {
  name: 'BionicMetricsAMacro',
  components: {
    BionicMetricsMonacoSimpleEditor,
    BionicMetricsNoData,
    BionicMetricsPageLoading
  },
  props: {
    id: {
      type: String
    }
  },
  async mounted() {
    await this.load();
  },
  computed: {
    key() {
      return get(this.transient, 'key');
    },
    accountName() {
      return get(this.transient, 'account.name');
    }
  },
  methods: {
    async load() {
      try {
        this.loading = true;
        this.transient = await SuperAdmin.getTransient(this.id);
        this.json = JSON.stringify(omit(this.transient, ['account']), false, 4);
      } catch (error) {
        this.loading = false;
        return this.abort();
      } finally {
        this.loading = false;
      }
    }
  },
  data() {
    return {
      json: null,
      transient: null,
      loading: false,
      showEditNameDialog: false,
      showGitDialog: false
    };
  }
};
</script>

<style lang="scss">
.full {
  width: 100%;
  height: 100%;
}

.transient {
  height: 100%;
  padding-bottom: 48px; // toolbar dense
}
</style>
